import React, { useEffect, useRef, useState } from 'react'
import { gsap } from 'gsap'
import styled from 'styled-components'
import { Link } from 'gatsby'
import Spacer from '../Spacer'
import Arrow from '../Button/arrow'
import PropTypes from 'prop-types'
import { theme } from '../../theme/theme'

const ParallaxButtonWrapper = styled.div`
    display: block;
    position: relative;
    padding: 0;
    float: left;
    color: #fff;
`

const StyledButton = styled.button`
    position: relative;
    border: none;
    padding: 10px 20px 10px 0;
    display: inline-flex;
    align-items: center;
    background: transparent;
    transition: all 0.5s ease-out;

    &:hover {
        img {
            right: -2rem;
        }
    }

    img {
        position: absolute;
        right: -1rem;
        transition: all 0.5s ease-out;
    }
`

const Text = styled.div`
    color: ${(props) => props.textColor};
    font-weight: ${(props) => props.textWeight};
    font-size: ${(props) => props.textSize};
    text-transform: ${(props) => props.textStyle};
    text-decoration: none;
`

const ParallaxButton = (props) => {
    const buttonRef = useRef()
    const linkRef = useRef()

    const [posX, setPosX] = useState(0)
    const [posY, setPosY] = useState(0)

    useEffect(() => {
        const cursor = document.getElementById('cursor_follower')

        const parallaxIt = (e, movement) => {
            let o = e.target
            const pos = o.getBoundingClientRect()

            let relX = e.clientX - pos.left
            let relY = e.clientY - pos.top

            setPosX(((relX - pos.width / 2) / pos.width) * movement)
            setPosY(((relY - pos.height / 2) / pos.height) * movement)
        }

        linkRef.current.addEventListener('mouseover', (e) => {
            cursor.classList.add('active')
        })

        linkRef.current.addEventListener('mouseleave', (e) => {
            cursor.classList.remove('active')
        })

        buttonRef.current.addEventListener('mouseleave', (e) => {
            setPosX(0)
            setPosY(0)
            cursor.classList.remove('active')
        })

        buttonRef.current.addEventListener('mousemove', (e) => {
            parallaxIt(e, 80)
        })

        gsap.to(buttonRef.current, {
            duration: 1,
            x: posX,
            y: posY,
            ease: 'Power2.easeOut',
        })
    })

    return (
        <ParallaxButtonWrapper ref={buttonRef}>
            <Link ref={linkRef} to={props.link}>
                <StyledButton>
                    <Text {...props}>{props.children}</Text>
                    <Spacer left="1" right="1" md={{ left: '0.2', right: '1' }} />
                    <Arrow color={props.arrowColor} size={props.arrowSize} />
                </StyledButton>
            </Link>
        </ParallaxButtonWrapper>
    )
}

ParallaxButton.propTypes = {
    link: PropTypes.string,
    borderColor: PropTypes.string,
    accentColor: PropTypes.string,
    arrowColor: PropTypes.string,
    arrowSize: PropTypes.string,
    size: PropTypes.string,
    textColor: PropTypes.string,
    textStyle: PropTypes.string,
    textSize: PropTypes.string,
    textWeight: PropTypes.string,
}

ParallaxButton.defaultProps = {
    link: '/',
    borderColor: `${theme.lightBlue}`,
    accentColor: `${theme.blue}`,
    arrowColor: 'white',
    arrowSize: '40',
    size: 'default',
    textColor: '#fff',
    textStyle: 'uppercase',
    textSize: '0.8em',
    textWeight: 'bold',
}

export default ParallaxButton
